import React from 'react';
import AppRouter from './AppRouter'; // ← 追加



function App() {
  return <AppRouter />;
}

export default App;
